import { projects } from '../lib/projects'
import ProjectCard from '../components/ProjectCard'
import { canAccessTool, useAccess, type ToolId } from '../lib/access'

export default function Dashboard() {
  const access = useAccess()

  if (access.loading) {
    return (
      <div className="flex items-center justify-center py-24">
        <div className="w-8 h-8 border-2 border-slate-300 dark:border-slate-600 border-t-blue-500 rounded-full animate-spin" />
      </div>
    )
  }

  // Only show the tools this user has been granted in the Admin panel.
  const visible = projects.filter((p) => canAccessTool(access, p.id as ToolId))

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Projects</h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1">
          Manage and monitor your active applications
        </p>
      </div>

      {visible.length === 0 && (
        <div className="text-center py-16 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl">
          <div className="text-4xl mb-3">🔒</div>
          <p className="text-slate-900 dark:text-white font-medium">No tools assigned to your account yet</p>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Ask Nathanael to grant you access from the Admin panel.</p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {visible.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>

      {/* Quick stats */}
      {visible.length > 0 && (
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
            <p className="text-slate-500 dark:text-slate-400 text-sm">Total Projects</p>
            <p className="text-2xl font-bold text-slate-900 dark:text-white mt-1">{visible.length}</p>
          </div>
          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
            <p className="text-slate-500 dark:text-slate-400 text-sm">Active</p>
            <p className="text-2xl font-bold text-emerald-600 dark:text-emerald-400 mt-1">
              {visible.filter((p) => p.status === 'active').length}
            </p>
          </div>
          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-4">
            <p className="text-slate-500 dark:text-slate-400 text-sm">In Development</p>
            <p className="text-2xl font-bold text-amber-600 dark:text-amber-400 mt-1">
              {visible.filter((p) => p.status === 'development').length}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
